import axiosClient from "api/axios_client.js";

const apiAccount = {
  // Update the logged-in user's own profile
  updateProfile: (id, payload) => axiosClient.put(`/user/update/${id}`, payload),
};

export default apiAccount;
